import React, {useEffect, useState} from "react";
import ReactModal from "react-modal";

import {FileUploadButton} from "../../../../common/button/file-upload-button/FileUploadButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import facilityIcon from "../../../../../resources/images/facility-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {createVisit, updateVisit} from "../../../../../services/VisitService";
import {convertDateToUTC} from "../../../../../util/DateUtil";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {FileListItem} from "../../../../common/list/file-list-item/FileListItem";
import {deleteFile} from "../../../../../services/FileService";
import {appBaseURL, downloadURL} from "../../../../../config/URLConfig";

export const TopicAreaFour = ({
                                  context,
                                  setContext,
                                  navigateTo,
                                  navigateBack,
                                  setSpinnerText,
                                  showToaster,
                                  toolTipsEnabled
                              }) => {
    ReactModal.setAppElement('#root');

    const [file, setFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [largeFileList, setLargeFileList] = useState([]);
    const [showFileSizeModal, setShowFileSizeModal] = useState(false);
    const [showDuplicateFileModal, setShowDuplicateFileModal] = useState(false);

    useEffect(() => {
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    topicAreaBreadcrumb: {
                        text: context.topicAreaScreen.topicArea.topicArea,
                        type: "Topic Area",
                        screenKey: "topicAreaOne",
                    }
                },
            }));
        }

        if (context.topicAreaScreen) {
            if (context.topicAreaScreen.fileList) {
                setFileList([...context.topicAreaScreen.fileList]);
            }
        }
    }, []);

    useEffect(() => {
        if (null !== file) {
            if (!fileList.some(fileInList => fileInList.name === file.name)) {
                setFileList((prevState) => ([...prevState, file]));
            } else {
                setShowDuplicateFileModal(true);
            }
        }
    }, [file]);

    const handleViewFileClick = (fileToView) => {
        window.open(appBaseURL + downloadURL + fileToView.externalReference);
    }

    const handleDeleteFileClick = async (fileToBeRemoved) => {
        if (fileToBeRemoved.externalReference) {
            const [data, error] = await deleteFile(context.username, fileToBeRemoved.externalReference);
            if (data) {
                if (data.responseStatus === "Success") {
                    let copyOfFileList = [...fileList];
                    let index = copyOfFileList.indexOf(fileToBeRemoved);
                    copyOfFileList.splice(index, 1);
                    setFileList([...copyOfFileList]);
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            let copyOfFileList = [...fileList];
            let index = copyOfFileList.indexOf(fileToBeRemoved);
            copyOfFileList.splice(index, 1);
            setFileList([...copyOfFileList]);
        }
    }

    const handleNextClick = async () => {
        const largeFiles = fileList.filter((file) => file.size > 16777216);
        if (largeFiles.length > 0) {
            setLargeFileList(largeFiles);
            setShowFileSizeModal(true);
        } else {
            await saveVisit();
        }
    }

    const saveVisit = async () => {
        setSpinnerText("Saving Visit");
        let dateOfNextVisit = null;
        if (context.problemScreen && context.problemScreen.nextVisitDate) {
            dateOfNextVisit = convertDateToUTC(context.problemScreen.nextVisitDate);
        }

        const visitToBeSaved = {
            externalReference: context.topicAreaScreen.visitExternalReference,
            dateOfVisit: convertDateToUTC(context.topicAreaScreen.dateOfVisit),
            dateOfNextVisit,
            grantExternalReference: context.topicAreaScreen.grant.externalReference,
            topicAreaExternalReference: context.topicAreaScreen.topicArea.externalReference,
            metWith: context.topicAreaScreen.contactPersonList,
            companions: context.topicAreaScreen.accompanyingPersonList,
            fileVOList: fileList,
            locationExternalReference: context.facilityScreen.locationExternalReference,
            indicatorExternalReference: context.topicAreaScreen.indicator.externalReference,
            systemUserExternalReference: context.topicAreaScreen.staffMember.externalReference,
        };

        if (!visitToBeSaved.externalReference) {
            const [data, error] = await createVisit(context.username, visitToBeSaved);
            if (data) {
                if (data.responseStatus === "Success") {
                    const uploadedFileList = fileList.map((file) => {
                        return {...file, uploaded: true}
                    });

                    setContext((prevState) => ({
                        ...prevState,
                        topicAreaScreen: {
                            ...prevState.topicAreaScreen,
                            fileList: uploadedFileList,
                            visitExternalReference: data.savedVisitVO.externalReference,
                        }
                    }));
                    navigateTo("problemOne");
                }
                showToaster(data);
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
        } else {
            const copyOfTopicAreaScreen = context.copyOfTopicAreaScreen;
            const currentTopicAreaScreen = JSON.stringify(context.topicAreaScreen);
            if (copyOfTopicAreaScreen === currentTopicAreaScreen && context.topicAreaScreen.fileList.length === fileList.length) {
                navigateTo("problemOne");
            } else {
                visitToBeSaved.fileVOList = visitToBeSaved.fileVOList.filter((file) => file.data !== "" && !file.uploaded);
                const [data, error] = await updateVisit(context.username, visitToBeSaved);
                if (data) {
                    if (data.responseStatus === "Success") {
                        const uploadedFileList = fileList.map((file) => {
                            return {...file, uploaded: true}
                        });

                        setContext((prevState) => ({
                            ...prevState,
                            topicAreaScreen: {
                                ...prevState.topicAreaScreen,
                                fileList: uploadedFileList,
                                visitExternalReference: data.updatedVisitVO.externalReference,
                            }
                        }));
                        navigateTo("problemOne");
                    }
                    showToaster(data);
                } else {
                    showToaster({
                        responseStatus: "Error",
                        responseMessage: error.message,
                    });
                }
            }
        }
        setSpinnerText(null);
    }

    const fileListItems = fileList.map((file, index) => {
        return (
            <FileListItem key={index}
                          context={context}
                          text={file.name}
                          showDownloadButton={context.viewMode && file.externalReference}
                          onDownloadClick={() => {
                              handleViewFileClick(file);
                          }}
                          onDeleteClick={() => {
                              handleDeleteFileClick(file)
                          }}
            />
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={facilityIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.facilityScreen.locationBreadCrumbText}</p>
                </div>
                <div className="wizard-right-container">
                    <div className={"label-div-tooltip-sv"}>
                        <label className="label">Site Visit Form:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"ta24SiteVisitForm1"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Site Visit Form:"}/>}
                    </div>
                    {fileListItems}
                    <FileUploadButton buttonText={"Select File"} setFile={setFile} disableButton={fileList.length > 4 || !context.editMode}/>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Visit"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.topicAreaScreen.visitExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton onClick={handleNextClick} disabled={fileList.length === 0}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showFileSizeModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">File Size Warning</p>
                    {largeFileList.length === 1 &&
                    <p className="file-warning-modal-text">
                        The following file is larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.length > 1 &&
                    <p className="file-warning-modal-text">
                        The following files are larger than 16MB and cannot be uploaded:
                    </p>}
                    {largeFileList.map((file, index) => {
                        return (<p className="file-warning-modal-text" key={index}>{file.name}</p>);
                    })}
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowFileSizeModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>

            <ReactModal isOpen={showDuplicateFileModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="file-warning-modal-content">
                    <p className="modal-title">Duplicate File</p>
                    <p className="file-warning-modal-text">That file has already been selected</p>
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowDuplicateFileModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
